import 'css-chunksrc/client/scenes/workloads/wbs/task/allocationsList/details/allocation/completion/styles.scss';export default {
  "progressBar": "_progressBar_zb3ug_1",
  "textProgressIndicator": "_textProgressIndicator_zb3ug_10"
};